var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1840 266",
    style: {
      enableBackground: "new 0 0 1840 266"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.1,5.9c3.5,0,5.7,2.1,5.7,5.7v21.3c0,3.5,2.1,5.7,5.7,5.7h21.2c3.5,0,5.7,2.1,5.7,5.7v62.1 c0,3.5-2.1,5.7-5.7,5.7h-21.2c-3.5,0-5.7,2.1-5.7,5.7v21.3c0,3.5-2.1,5.7-5.7,5.7H38.4c-3.5,0-5.7,2.1-5.7,5.7v103.2 c0,3.5-2.1,5.7-5.7,5.7H5.9c-3.5,0-5.7-2.1-5.7-5.7V11.6c0-3.5,2.1-5.7,5.7-5.7H157.1z M32.8,106.3c0,3.5,2.1,5.7,5.7,5.7h118.7 c3.5,0,5.7-2.1,5.7-5.7V44.2c0-3.5-2.1-5.7-5.7-5.7H38.4c-3.5,0-5.7,2.1-5.7,5.7V106.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.6,259.1V5.9h174.2v28.4H261.2v80.5h131.1v28.4H261.2v87.6h141.7v28.4H227.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.4,259.1V5.9h35.7l132.8,205.4h0.7V5.9h31.8v253.2h-36.7L466.9,55.9h-0.7v203.2H434.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M831.3,5.9c3.5,0,5.7,2.1,5.7,5.7v21.3c0,3.5,2.1,5.7,5.7,5.7h21.2c3.5,0,5.7,2.1,5.7,5.7v176.6 c0,3.5-2.1,5.7-5.7,5.7h-21.2c-3.5,0-5.7,2.1-5.7,5.7v21.3c0,3.5-2.1,5.7-5.7,5.7H680.1c-3.5,0-5.7-2.1-5.7-5.7V11.6 c0-3.5,2.1-5.7,5.7-5.7H831.3z M707,220.8c0,3.5,2.1,5.7,5.7,5.7h118.7c3.5,0,5.7-2.1,5.7-5.7V44.2c0-3.5-2.1-5.7-5.7-5.7H712.6 c-3.5,0-5.7,2.1-5.7,5.7V220.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1112.2,5.9v161.7c0,63.8-36.4,97.5-99.3,97.5c-65,0-103.5-30.1-103.5-97.5V5.9H943v161.7 c0,44.7,25.4,69.2,69.9,69.2c42.4,0,65.7-24.5,65.7-69.2V5.9H1112.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1146.6,259.1V5.9h33.6v224.9h133.5v28.4H1146.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1378.4,5.9c3.5,0,5.6,2.1,5.6,5.7v209.3c0,3.5,2.1,5.7,5.7,5.7h118.7c3.5,0,5.6-2.1,5.6-5.7V11.6 c0-3.5,2.1-5.7,5.7-5.7h21.2c3.5,0,5.6,2.1,5.6,5.7v209.3c0,3.5-2.1,5.7-5.6,5.7h-21.2c-3.5,0-5.7,2.1-5.7,5.7v21.3 c0,3.5-2.1,5.7-5.6,5.7h-118.7c-3.5,0-5.7-2.1-5.7-5.7v-21.3c0-3.5-2.1-5.7-5.6-5.7h-21.2c-3.5,0-5.7-2.1-5.7-5.7V11.6 c0-3.5,2.1-5.7,5.7-5.7H1378.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1587.3,259.1V5.9h45.9l79.5,212.8l79.8-212.8h45.9v253.2h-31.8V48.5h-0.7l-78.8,210.7h-28.6l-78.8-210.7h-0.7 v210.7H1587.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.858a5a2cc25bad63c2b27ff7e429e0b8.svg";
export { ForwardRef as ReactComponent };